export default __webpack_public_path__ + "static/media/logo.2b0e5a79.png";